module.exports = __webpack_public_path__ + "public/img/card_book.7d8744b6.png";